import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type AllLegacyAccountsQueryVariables = GraphQLTypes.Exact<{
  searchQuery?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type AllLegacyAccountsQueryResult = { __typename?: 'Query' } & {
  legacyAccounts: { __typename?: 'LegacyAccountConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<
          { __typename?: 'LegacyAccount' } & Pick<GraphQLTypes.LegacyAccount, 'name' | 'uuid'> & {
              division?: GraphQLTypes.Maybe<
                { __typename?: 'Division' } & Pick<GraphQLTypes.Division, 'accountId' | 'id' | 'name'>
              >;
            }
        >
      >
    >;
  };
};

export const AllLegacyAccountsDocument = gql`
  query allLegacyAccounts($searchQuery: String) {
    legacyAccounts(textContains: $searchQuery, paginated: false) {
      nodes {
        division {
          accountId
          id
          name
        }
        name
        uuid
      }
    }
  }
`;
